import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {LoadingIndicatorComponent} from '@shared/loading-indicator/loading-indicator.component';
import {NotificationContainerComponent} from '@shared/notification/notification-container.component';
import {TableHeaderSortableDirective} from '@shared/table-header-sortable/table-header-sortable.directive';
import {ConfirmationDialogComponent} from '@shared/confirmation-dialog/confirmation-dialog.component';
import {PageSummaryComponent} from '@shared/page-summary/page-summary.component';
import {RequiredFieldIndicatorComponent} from '@shared/required-field-indicator/required-field-indicator.component';
import {
  RequiredFieldIndicatorExplanationComponent
} from '@shared/required-field-indicator-explanation/required-field-indicator-explanation.component';
import {
  InlineEditInputFieldComponent
} from '@shared/inline-edit-input-field/inline-edit-input-field.component';
import {BreadcrumbComponent} from '@shared/breadcrumb/breadcrumb.component';
import {FileUploadComponent} from '@shared/file-upload/file-upload.component';
import {FileDownloadComponent} from '@shared/file-download/file-download.component';
import {GlobalPageHeaderComponent} from '@shared/global-page-header/global-page-header.component';
import {ModalFooterComponent} from '@shared/modal-footer/modal-footer.component';
import {DateTimePickerComponent} from '@shared/date-time-picker/date-time-picker.component';
import {ColorPickerComponent} from '@shared/color-picker/color-picker.component';
import {ColorPickerDirective} from 'ngx-color-picker';
import {SelectMachinesDropdownComponent} from '@shared/select-machines/select-machines-dropdown.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {ToggleArrowComponent} from '@shared/toggle-arrow/toggle-arrow.component';
import {TreeListComponent} from '@shared/tree-list/tree-list.component';
import {SearchSelectComponent} from '@shared/search-select/search-select.component';
import {NgxPaginationModule} from 'ngx-pagination';
import {NgxPaginationComponent} from '@shared/ngx-pagination/ngx-pagination.component';


@NgModule({
  declarations: [
    LoadingIndicatorComponent,
    NotificationContainerComponent,
    ConfirmationDialogComponent,
    TableHeaderSortableDirective,
    PageSummaryComponent,
    RequiredFieldIndicatorComponent,
    RequiredFieldIndicatorExplanationComponent,
    InlineEditInputFieldComponent,
    BreadcrumbComponent,
    InlineEditInputFieldComponent,
    FileUploadComponent,
    FileDownloadComponent,
    ModalFooterComponent,
    GlobalPageHeaderComponent,
    DateTimePickerComponent,
    ColorPickerComponent,
    SelectMachinesDropdownComponent,
    ToggleArrowComponent,
    TreeListComponent,
    NgxPaginationComponent,
    SearchSelectComponent
  ],
  exports: [
    LoadingIndicatorComponent,
    NotificationContainerComponent,
    TableHeaderSortableDirective,
    PageSummaryComponent,
    RequiredFieldIndicatorComponent,
    RequiredFieldIndicatorExplanationComponent,
    InlineEditInputFieldComponent,
    BreadcrumbComponent,
    FileUploadComponent,
    FileDownloadComponent,
    ModalFooterComponent,
    GlobalPageHeaderComponent,
    DateTimePickerComponent,
    ColorPickerComponent,
    SelectMachinesDropdownComponent,
    ToggleArrowComponent,
    TreeListComponent,
    SearchSelectComponent,
    NgxPaginationModule,
    NgxPaginationComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ColorPickerDirective,
    NgSelectModule,
    NgxPaginationModule
  ]
})
export class SharedModule {
}
